import { repeatedVisitKey } from '../../constants/routes';
export const defaultHomeProps = {
  usageTracker: {
    trackInteraction: () => undefined,
    trackPageView: () => undefined,
    trackUsage: () => undefined
  },
  repeatedVisitKey,
  meetingContext: {},
  isLoading: false,
  unauthorizedRoutesParam: '',
  accountsRoute: '',
  fetchUserInfo: () => Promise.resolve({
    userId: 0,
    email: '',
    firstName: '',
    lastName: '',
    enabledGates: [],
    locale: {
      locale: 'en',
      langEnabled: false
    }
  })
};